import type {QueriesType} from "../../types";
import type {RelationsType} from "../../types-analytics";

export class featureRestoreRemovedFilters {

    private queries: QueriesType = {};
    private related: RelationsType = [];
    private _isSet: boolean = false;

    constructor() {
        this._isSet = false;
    }

    public setLastRemovedFilter(queries: QueriesType, related: RelationsType ): void {
        this.queries = queries;
        this.related = related;
        this._isSet = true;
    }

    public isSet(): boolean {
        return this._isSet;
    }

    public clear(): void {
        this.queries = {};
        this.related = [];
        this._isSet = false;
    }

    public isEmpty(): boolean {
        return Object.keys(this.queries).length === 0 && this.related.length === 0;
    }

    public getLastRemovedFilter(): { queries: QueriesType, related: RelationsType } {
        return { queries: this.queries, related: this.related };
    }

}